import { useState, useEffect } from 'react';
import {
  Box,
  Switch,
  FormControlLabel,
  TablePagination,
  TablePaginationProps,
} from '@mui/material';
import { Theme, SxProps } from '@mui/material/styles';

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function CasTablePagination({
  dense,
  onChangeDense,
  rowsPerPageOptions: parmRowsPerPageOptions = [5, 10, 20],
  rowsPerPage,
  sx,
  ...other
}: Props & TablePaginationProps) {
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(parmRowsPerPageOptions);

  useEffect(() => {
    setRowsPerPageOptions((prevOptions) => {
      if (prevOptions.includes(rowsPerPage)) return prevOptions;
      return [...prevOptions, rowsPerPage].sort((a: any, b: any) => a - b);
    });
  }, [rowsPerPage]);

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        rowsPerPage={rowsPerPage}
        component="div"
        {...other}
        sx={{
          borderTopColor: 'transparent',
        }}
      />

      {onChangeDense && (
        <FormControlLabel
          label="Dense"
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,
            position: {
              sm: 'absolute',
            },
          }}
        />
      )}
    </Box>
  );
}
